export const HEIGHT_OF_EACH_DROPDOWN_ELEMENT = 28;
export const MAX_AMOUNT_OF_DROPDOWN_ELEMENTS_TO_SHOW = 15;
